export default __webpack_public_path__ + "static/media/umeria.a77efbac.jpeg";